const InputValidator = (input_type, value) => {
    let re = "";
    switch (input_type) {
      case "email":
        re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        return re.test(value);
  
      case "tel":
        re = /^(\+{0,1}\d{11,13})$/;
        return re.test(value);
  
      case "password":
        return (value !== "" && value.length > 5);
  
      default:
        return (value !== "");
    }
  };
  
  export default InputValidator;


// WEBPACK FOOTER //
// ./src/utils/validators.js